<div class="wrapper-reponsive">
    <!-- Start màn 4 -->
    <div class="tlt-green-row mt-3">
        {{  'STR_USER_INFO_INPUT' | translate  }}
    </div>
    <div class="content-box mt-2 mb-2">
        <p class="p-2">
          {{ 'STR_USER_INFO_NOTE' | translate}}
        </p>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_NAME' | translate}} 
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input id="Name" type="text" class="form-control ctrl1" [(ngModel)]="user.Name" (ngModelChange)="removeErrBorder(1)" maxlength="80">
               
            </div>
            <div  *ngIf="isRequireName" class="pl-3 err-validate validate-name">
                <span>{{ getRequireMsg('STR_NAME') }}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_KANA_NAME' | translate}} 
                    <div class="mark-right" *ngIf="user.CountryCode=='JP'">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input id="KanaName" type="text" placeholder="{{'STR_KANA_NAME_PLACEHOLDER' | translate}}" class="form-control ctrl2"  [(ngModel)]="user.KanaName"  (ngModelChange)="removeErrBorder(2)" (keypress)="onKeyPressInput($event)" maxlength="80">
               
            </div>
            <div  *ngIf="isRequireKana" class="pl-3 err-validate validate-name">
                <span>{{ kanaErrMsg }}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_DATEOFBIRTH' | translate }} 
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
            
               <app-date-inp  [strId]="'inpDOD'"  [strDate]="user.DateOfBirth" (evReturn)="ChangeDOB($event)"></app-date-inp>
            </div>
            <div id="DateBirth" *ngIf="isRequireDob" class="pl-3 err-validate validate-name">
                <span>{{ getRequireMsg('STR_DATEOFBIRTH') }}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_GENDER' | translate}} 
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <div class="row mt-2">
                    <div class="col-4">
                        <label class="custom-radio">{{'STR_GENDER_MALE' | translate}}
                            <input type="radio" name="radio" id="1" class="ctrl4"   [(ngModel)]="user.Gender" [value]="'1'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                    <div class="col-4">
                        <label class="custom-radio">{{'STR_GENDER_FEMALE' | translate}}
                            <input type="radio" name="radio" id="2"   class="ctrl4"    [(ngModel)]="user.Gender" [value]="'2'">
                            <span class="checkmark"></span>
                        </label>
                    </div>
                </div>
               
            </div>
            <div *ngIf="isRequireGender" class="pl-3 err-validate">
                <span>{{ getRequireMsg('STR_GENDER') }}</span>
            </div>
        </div>
        <div id="phone" class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_PHONENUM' | translate}} 
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <app-phone-number [strId]="'PhoneNum'" [length] = "15" class="ctrl5" [inValue]="user.PhoneNum" (newItemEvent)="setValuePhoneNum($event)"
                [ngClass]="'w190 mr-90'" ></app-phone-number>
               
            </div>
            <div  *ngIf="isRequirePhoneNum" class="pl-3 err-validate  validate-name">
                <span>{{ getRequireMsg('STR_PHONENUM') }}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_ADDRESS' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <input id="PostalCode" type="text"  postalForm numberForm
                [(ngModel)]="strPostalCode" placeholder="{{ 'STR_POSTALNUM' | translate }}"  class="form-control d-inline-block w200 mr-2 ctrl8"
                (focus)="focusPostNum(strPostalCode)" (focusout)="outFocusPostNum(strPostalCode)"  (ngModelChange)="removeErrBorder(8)" minlength="10">
                <button class="btn-search-green mb-2" (click)="onClickSearchAddress()">
                  <img src="../../../../../assets/img/icon_search.png" alt="">
                </button>
            </div>
            <div  *ngIf="isRequirePostalCode" class="pl-3 err-validate mgb5">
                    <span>{{ getRequireMsg('STR_POSTALNUM') }}</span>
            </div>
            <div class="pl-3">
                <app-inp-postal-code [idInp]="'inpAddress'" [maxLength]="maxLength" [data]="lstPostal" [inpClss]="inpPostalClss" 
                (outPostal)="SetValue($event, 'Adress1', 'Adress2')"></app-inp-postal-code>
        
            </div>
            <div  *ngIf="isRequireAddress1" class="pl-3 err-validate  validate-name">
                <span>{{ getRequireMsg('STR_ADDRESS1') }}</span>
            </div>
            <div class="pl-3">
                <input type="text" class="form-control mt-2" [(ngModel)]="user.Adress2" maxlength="255"  placeholder="{{'STR_NEXT_ADDRESS_PLACEHOLDER' | translate}}" >
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_EMAIL_ADDRESS' | translate}}
                </div>
                <p class="p-2">
                    {{user.MailAdress}}
                </p>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-2">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_PASSWORD' | translate}}
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <p class="p-2">
                   {{'STR_PASSWORD_NOTE' | translate}}
                </p>
                <input id="Password" type="password" class="form-control mb-2 ctrl6" [(ngModel)]="user.Password" maxlength="16" 
                (keyup)="onKeyTodo($event)"   (input)="checkPwd($event)" (paste)="onPaste($event)" >
            </div>
            <div  *ngIf="isRequirePassword" class="pl-3 err-validate mgb5">
                <span>{{ pwdErrMsg }}</span>
            </div>
            <div class="pl-3">
                <input id="PasswordCheck" type="password" placeholder="{{'STR_CONFIRM_PASSWORD_PLACEHOLDER' | translate}}" class="form-control ctrl7" maxlength="16" [(ngModel)]="passConfirm"   (keyup)="onKeyTodo($event)"   (input)="checkPwd($event)" (paste)="onPaste($event)" >
            </div>
            <div  *ngIf="isRequirePasswordCf" class="pl-3 err-validate  validate-name">
                <span>{{ pwdCfErrMsg }}</span>
            </div>
            <div  *ngIf="isPasswordCfNotSame" class="pl-3 err-validate  validate-name">
                <span>{{'MESS_PW_CNFPW_NOT_SAME' | translate}}</span>
            </div>
        </div>
        <div class="row-input row-input-auto-height p-4 mb-4">
            <div class="pl-3">
                <div class="tlt-dot mb-1">{{'STR_SERVICE_TERM' | translate}} 
                    <div class="mark-right">{{'STR_REQUIRED' | translate}}</div>
                </div>
                <p class="p-2">
                   {{'STR_SERVICE_TERM_NOTE' | translate}}
                </p>
                <a href="/service-terms" target="_blank">
                    <strong>{{'STR_SERVICE_TERM_URL' | translate}}</strong>
                </a>
                <div class="mt-4">
                    <label class="custom-checkbox">
                       {{'STR_SERVICE_TERM_AGREE' | translate}}
                        <input id="Policy" type="checkbox" [(ngModel)]="agreePolicy">
                        <span class="checkmark"></span>
                    </label>
                  
                </div>
            </div>
            <div  *ngIf="isPolicyErr" class="pl-3 err-validate">
                <span>{{'MESS_ERR_USING_RULE_NEEDTOBE_ACCEPTED' | translate}}</span>
            </div>
        </div>
        <div class="text-center mt-2">
            <button class="btn btn-common btn-bg-green" (click)="regis()">
                {{'STR_BTN_REGIS' | translate}}
            </button>
        </div>
    </div>
    <!-- End màn 4 -->
</div>